export default __webpack_public_path__ + "static/media/microsoft.de66fd3d.jpg";